<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M7.29,11.71C7.47,11.89,7.72,12,8,12C8.28,12,8.53,11.89,8.71,11.71C8.71,11.71,12.71,7.71,12.71,7.71C12.89,7.53,13,7.28,13,7C13,6.45,12.55,6,12,6C11.72,6,11.47,6.11,11.29,6.29C11.29,6.29,9,8.59,9,8.59C9,8.59,9,1,9,1C9,0.45,8.55,0,8,0C7.45,0,7,0.45,7,1C7,1,7,8.59,7,8.59C7,8.59,4.71,6.29,4.71,6.29C4.53,6.11,4.28,6,4,6C3.45,6,3,6.45,3,7C3,7.28,3.11,7.53,3.29,7.71C3.29,7.71,7.29,11.71,7.29,11.71C7.29,11.71,7.29,11.71,7.29,11.71ZM15,11C14.45,11,14,11.45,14,12C14,12,14,14,14,14C14,14,2,14,2,14C2,14,2,12,2,12C2,11.45,1.55,11,1,11C0.45,11,0,11.45,0,12C0,12,0,15,0,15C0,15.55,0.45,16,1,16C1,16,15,16,15,16C15.55,16,16,15.55,16,15C16,15,16,12,16,12C16,11.45,15.55,11,15,11C15,11,15,11,15,11Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'Import',
} as DefineComponent
</script>
